export default __webpack_public_path__ + "static/media/habilitar-permiso-camara-windows-2.af047af2.svg";